<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">
          {{ $route.query && $route.query.name }}
        </div>
        <div>
          <bread-crumb :bread-crumbs="['Sample Ledger']" />
        </div>
      </v-card-title>

      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        :items="AccountSummary"
        :search="search"
        dense
        item-key="id"
      >
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              title="View/Edit"
              color="primary"
              class="mr-2"
              @click="getLedgerDetailsById(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              title="Delete"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>
        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-row class="ms-1 me-1 mt-5">
            <div class="d-flex">
              <v-btn
                depressed
                small
                class="text-capitalize text-decoration-none me-2"
                color="primary"
                @click="openDialog"
                ><v-icon small class="me-2">mdi-plus</v-icon>Add New</v-btn
              >
            </div>
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="me-2"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-10"
              dense
              clearable
            ></v-text-field>
          </v-row>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="500">
        <v-card v-if="showDialog">
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="secondary" dark flat dense>
              <span>{{ formtitle }} New Ledger</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Ledger Name
                  </label>
                  <v-text-field
                    v-model="ledgerDetails.name"
                    class="rounded"
                    :rules="[
                      ...FieldRequired('Ledger Name'),
                      ...ledgerNamerules,
                    ]"
                    dense
                    outlined
                    placeholder="Ledger Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Opening Balance
                  </label>
                  <v-text-field
                    v-model="ledgerDetails.amount"
                    type="number"
                    hide-spin-buttons
                    @keydown="filterNumberInput"
                    @keypress="roundedValue"
                    class="rounded"
                    :rules="FieldNumbRequired('Opening Balance')"
                    dense
                    outlined
                    placeholder="Opening Balance"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="ledgerDetails.amount_type"
                    class="rounded"
                    dense
                    outlined
                    :rules="FieldRequired('Field')"
                    placeholder="Select Amount Type"
                    item-text="txt"
                    item-value="val"
                    :items="credittypes"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize">
                    Ext Branch Code
                  </label>
                  <v-text-field
                    v-model="ledgerDetails.branch_cd"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Enter Branch Code"
                  ></v-text-field>
                </v-col> -->
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    justify-content: right;
                    margin-top: 8px;
                    margin-bottom: 8px;
                  "
                >
                  <v-btn
                    depressed
                    color="primary"
                    min-width="170px"
                    class="me-5 text-capitalize"
                    @click="onSubmitFor()"
                  >
                    {{ ledgerDetails.id ? "Update" : "Add" }}
                  </v-btn>

                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    outlined
                    min-width="170px"
                    @click="closeDialog()"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                    >Cancel
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="showBlockDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete ?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteLedgerById()"
            >
              Delete<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="showBlockDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import {
  FieldRequired,
  ledgerRules,
  FieldNumbRequired,
} from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import setupService from "@/services/SetupService/setupService.js";
import commonService from "@/services/CommonService/commonService.js";
export default {
  mixins: [alerts],
  name: "Sample Ledger",
  data() {
    return {
      FieldRequired,
      FieldNumbRequired,
      ...ledgerRules,
      filterNumberInput,
      search: "",
      dialogDelete: false,
      showBlockDialog: false,
      isActive: null,
      blockId: null,
      loader: false,
      showDialog: false,
      valid: true,
      editedIndex: -1,
      title_text: "",
      credittypes: [],
      selectedCountry: "",
      selectedPayment: "",
      acc_id: null,
      headers: [
        {
          text: "Id",
          sortable: false,
          value: "id",
        },
        { text: "Name", value: "name" },
        { text: "Amount", value: "amount" },
        { text: "Amount Type", value: "amount_type" },
        // { text: "External Code", value: "branch_cd" },
        { text: "Action", value: "action", sortable: false },
      ],
      AccountSummary: [],
      ledgerDetails: {
        ledger_id: 0,
        name: "",
        amount: 0,
        amount_type: "",
        branch_cd: "",
      },
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  mounted() {
    this.getallLedgerDetailsById();
    this.getparameterDropdown("CRDR");
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  methods: {
    roundedValue(event) {
      if (
        this.ledgerDetails.amount != null &&
        this.ledgerDetails.amount.indexOf(".") > -1 &&
        this.ledgerDetails.amount.split(".")[1].length > 1
      ) {
        event.preventDefault();
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.AccountSummary) {
        this.exportToExcel(this.headers, this.AccountSummary, "AccountSummary");
      }
    },
    async getparameterDropdown(code) {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          this.credittypes = response.data.data.map((i) => {
            return { txt: i.value, val: i.value_code };
          });

          this.loader = false;
        } else {
          this.loader = false;
        }
      } catch (error) {
        this.loader = false;
        console.error(error);
      }
    },
    editItem() {
      this.editedIndex = 1;
      this.showDialog = true;
    },
    openDialog() {
      this.showDialog = true;
      this.ledgerDetails.id = "";
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
        this.$refs.Addform.reset();
      }
      this.ledgerDetails.amount = 0;
    },

    closeDialog() {
      this.loader = false;
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
      this.$refs.Addform.reset();
      this.ledgerDetails.amount = 0;
    },

    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.ledgerDetails.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    deleteItem(item) {
      this.showBlockDialog = true;
      this.delete_id = item.id;
    },
    async getLedgerDetailsById(item) {
      this.loader = true;
      try {
        const responseData = await setupService.getLedgerDetailsById(item.id);
        console.log(`up: ${JSON.stringify(responseData)}`);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          // this.showAlertSuccess(responseData.data.message);
          this.ledgerDetails = responseData.data.data[0];
          this.showDialog = true;
        } else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async getallLedgerDetailsById() {
      this.loader = true;
      try {
        const responseData = await setupService.getallLedgerDetailsById(
          this.$route.query.id
        );
        console.log(`up: ${JSON.stringify(responseData)}`);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.AccountSummary = responseData.data.data.reverse();
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.loader = false;
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async deleteLedgerById() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteLedgerDetailsById(
          this.delete_id
        );
        console.log(`up: ${JSON.stringify(responseData)}`);

        if (responseData.data.status_code === 200) {
          this.loader = false;
          this.showBlockDialog = false;
          this.getallLedgerDetailsById();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.loader = false;
          this.showBlockDialog = false;
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.loader = false;
        this.showBlockDialog = false;
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async save() {
      this.loader = true;
      this.ledgerDetails.ledger_id = this.$route.query.id;
      try {
        const responseData = await setupService.addLedgerDetails(
          this.ledgerDetails
        );
        console.log(`up: ${JSON.stringify(responseData)}`);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.getallLedgerDetailsById();
          this.showAlertSuccess(responseData.data.message);
          this.showDialog = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async update() {
      this.loader = true;
      this.ledgerDetails.ledger_id = this.$route.query.id;
      try {
        const responseData = await setupService.updateledgerDetailsById(
          this.ledgerDetails.id,
          this.ledgerDetails
        );
        console.log(`up: ${JSON.stringify(responseData)}`);
        setTimeout(() => {
          this.loader = false;
        }, 300);
        if (responseData.data.status_code === 200) {
          this.getallLedgerDetailsById();
          this.showAlertSuccess(responseData.data.message);
          this.showDialog = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },

    navBranchList(item) {
      this.$router.push({ name: "Sample Ledger", query: { acc_id: item.id } });
    },
    openBlockDialog(item) {
      this.title_text = item.status ? "Active" : "Deactive";
      this.showBlockDialog = true;
      this.isActive = item.status;
      this.blockId = item.partner_id;
    },
    confirmBlock() {
      this.showBlockDialog = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
</style>
